module.exports = __webpack_public_path__ + "img/choose-up-cultura-disabled.9a04c178.png";